import * as Cookie from "@/localCache/cookie";

/**
 * @FileDescription: 用户数据
 * @Author: zhuangjinshan
 * @Date: 2023-08-16
 * @LastEditors: chenw
 * @LastEditTime: 2025-10-21
 */
export default {
  state: {
    currentUser: null,
    token: '',
    isLoggIn: false // 是否已登录
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      state.isLoggIn = !!token;
    },
    SET_CURRENT_USER: (state, currentUser) => {
      state.currentUser = currentUser;
    },
    REMOVE_DATA: (state, prop) => {
      state[prop] = null;
    }
  },
  actions: {
    setToken(context, token) {
      Cookie.setToken(token);
      context.commit('SET_TOKEN', token);
    },
    setCurrentUser({ commit }, currentUser) {
      commit('SET_CURRENT_USER', currentUser);
    },
    userClear({ commit }) {
      commit('REMOVE_DATA', 'currentUser');
    },
    /**
     * 退出登录
     */
    logout({ commit }) {
      Cookie.removeToken();
      commit('SET_TOKEN', '');
      commit('SET_CURRENT_USER', null);
    }
  }
}
